import { render, staticRenderFns } from "./new.specialties.page.vue?vue&type=template&id=39cfdcf3&"
import script from "./new.specialties.page.vue?vue&type=script&lang=js&"
export * from "./new.specialties.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports